import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  createThis2j2avj17cvnv2 as createThis,
  hashCodeq5arwsb9dgti as hashCode,
  getBigIntHashCode294hi5bdhtj6e as getBigIntHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.h3o_1 = 1048576;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var FinalClass;
function Final() {
  if (FinalClass === VOID) {
    class $ extends Final_1() {
      static l3o(lo, hi, isBits) {
        var $this = this.n3o(isBits);
        $this.j3o_1 = lo;
        $this.k3o_1 = hi;
        return $this;
      }
      static o3o(lo, hi) {
        return this.l3o(lo, hi, false);
      }
      we() {
        return this.j3o_1;
      }
      xe() {
        return this.k3o_1;
      }
      p3o() {
        if (this.m3o_1)
          return this;
        return Final().l3o(this.j3o_1 << 3, this.k3o_1 << 3 | (this.j3o_1 >>> 29 | 0), true);
      }
    }
    initMetadataForClass($, 'Final');
    FinalClass = $;
  }
  return FinalClass;
}
function init_org_kotlincrypto_bitops_bits_Counter_Bit32(_this__u8e3s4) {
}
var FinalClass_0;
function Final_0() {
  if (FinalClass_0 === VOID) {
    class $ extends Final_1() {}
    initMetadataForClass($, 'Final');
    FinalClass_0 = $;
  }
  return FinalClass_0;
}
var Bit32Class;
function Bit32() {
  if (Bit32Class === VOID) {
    class $ extends Counter() {
      static u3o(lo, hi, incrementBy) {
        var $this = this.w3o();
        init_org_kotlincrypto_bitops_bits_Counter_Bit32($this);
        // Inline function 'kotlin.require' call
        if (!(incrementBy > 0)) {
          var message = 'incrementBy[' + incrementBy + '] must be greater than 0';
          throw IllegalArgumentException().n2(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(incrementBy <= 1048576)) {
          var message_0 = 'incrementBy[' + incrementBy + '] must be less than or equal to 1048576';
          throw IllegalArgumentException().n2(toString(message_0));
        }
        // Inline function 'kotlin.require' call
        if (!((incrementBy % 8 | 0) === 0)) {
          var message_1 = 'incrementBy[' + incrementBy + '] must be a factor of 8';
          throw IllegalArgumentException().n2(toString(message_1));
        }
        // Inline function 'kotlin.require' call
        if (!((-2147483648 % incrementBy | 0) === 0)) {
          var message_2 = 'Int.MIN_VALUE % incrementBy[' + incrementBy + '] != 0';
          throw IllegalArgumentException().n2(toString(message_2));
        }
        // Inline function 'kotlin.require' call
        if (!((lo % incrementBy | 0) === 0)) {
          var message_3 = 'lo must be a factor of incrementBy[' + incrementBy + ']';
          throw IllegalArgumentException().n2(toString(message_3));
        }
        $this.r3o_1 = incrementBy;
        $this.s3o_1 = lo;
        $this.t3o_1 = hi;
        return $this;
      }
      static x3o(incrementBy) {
        return this.u3o(0, 0, incrementBy);
      }
      y3o() {
        this.s3o_1 = this.s3o_1 + this.r3o_1 | 0;
        if (this.s3o_1 === 0) {
          this.t3o_1 = this.t3o_1 + 1 | 0;
        }
      }
      z3o(additional) {
        var lo = this.s3o_1;
        var hi = this.t3o_1;
        var lt0 = lo < 0;
        lo = lo + additional | 0;
        if (lt0 && lo >= 0) {
          hi = hi + 1 | 0;
        }
        return Final().o3o(lo, hi);
      }
      a3p() {
        this.s3o_1 = 0;
        this.t3o_1 = 0;
      }
    }
    initMetadataForClass($, 'Bit32');
    Bit32Class = $;
  }
  return Bit32Class;
}
var Bit64Class;
function Bit64() {
  if (Bit64Class === VOID) {
    class $ extends Counter() {}
    initMetadataForClass($, 'Bit64');
    Bit64Class = $;
  }
  return Bit64Class;
}
var FinalClass_1;
function Final_1() {
  if (FinalClass_1 === VOID) {
    class $ {
      static n3o(isBits) {
        var $this = createThis(this);
        $this.m3o_1 = isBits;
        return $this;
      }
      equals(other) {
        var tmp;
        if (other instanceof Final_1()) {
          tmp = hashCode(other) === this.hashCode();
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        var result = 17;
        if (this instanceof Final()) {
          result = imul(result, 31) + this.j3o_1 | 0;
          result = imul(result, 31) + this.k3o_1 | 0;
        } else {
          if (this instanceof Final_0()) {
            result = imul(result, 31) + getBigIntHashCode(this.c3p_1) | 0;
            result = imul(result, 31) + getBigIntHashCode(this.d3p_1) | 0;
          }
        }
        result = imul(result, 31) + getBooleanHashCode(this.m3o_1) | 0;
        return result;
      }
      toString() {
        var tmp;
        if (this instanceof Final()) {
          tmp = 'Counter.Bit32.Final[lo=' + this.j3o_1 + ', hi=' + this.k3o_1 + ']';
        } else {
          if (this instanceof Final_0()) {
            tmp = 'Counter.Bit64.Final[lo=' + this.c3p_1.toString() + ', hi=' + this.d3p_1.toString() + ']';
          } else {
            noWhenBranchMatchedException();
          }
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'Final');
    FinalClass_1 = $;
  }
  return FinalClass_1;
}
var CounterClass;
function Counter() {
  if (CounterClass === VOID) {
    class $ {
      static w3o() {
        var $this = createThis(this);
        $this.v3o_1 = new Object();
        return $this;
      }
      equals(other) {
        var tmp;
        if (other instanceof Counter()) {
          tmp = hashCode(other) === this.hashCode();
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return 527 + hashCode(this.v3o_1) | 0;
      }
      toString() {
        var tmp;
        if (this instanceof Bit32()) {
          tmp = 'Bit32[lo=' + this.s3o_1 + ', hi=' + this.t3o_1 + ', incrementBy=' + this.r3o_1 + ']';
        } else {
          if (this instanceof Bit64()) {
            tmp = 'Bit64[lo=' + this.g3p_1.toString() + ', hi=' + this.h3p_1.toString() + ', incrementBy=' + this.f3p_1.toString() + ']';
          } else {
            noWhenBranchMatchedException();
          }
        }
        // Inline function 'kotlin.let' call
        return 'Counter.' + tmp + '@' + this.hashCode();
      }
    }
    initMetadataForClass($, 'Counter');
    CounterClass = $;
  }
  return CounterClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Bit32 as Bit3217m1n1f00xdaa,
};
//endregion

//# sourceMappingURL=Counter.mjs.map
